import apiClient from "./client";

export const getUsers = async () => {
  const response = await apiClient.get("/users");
  return response.data;
};

export const createUser = async ({ username, password, role }) => {
  const response = await apiClient.post("/users", { username, password, role });
  return response.data;
};

export const updateUser = async ({ id, password, role, isActive, authenticatedUserId }) => {
  const payload = {};
  if (typeof password !== "undefined") payload.password = password;
  if (typeof role !== "undefined") payload.role = role;
  if (typeof isActive !== "undefined") payload.isActive = isActive;
  if (typeof authenticatedUserId !== "undefined") payload.authenticatedUserId = authenticatedUserId;
  const response = await apiClient.put(`/users/${id}`, payload);
  return response.data;
};

export const deleteUser = async ({ id }) => {
  await apiClient.delete(`/users/${id}`);
};
